import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12" fill="#D80027" />
      <path
        d="M7.30432 6.26082C7.30432 4.51247 8.53306 3.05194 10.1739 2.69358C9.9168 2.63728 9.65441 2.60882 9.39125 2.60869C7.37417 2.60869 5.73907 4.24379 5.73907 6.26086C5.73907 8.27794 7.37417 9.91304 9.39125 9.91304C9.65998 9.91304 9.92164 9.88318 10.1739 9.8281C8.53306 9.46974 7.30432 8.00921 7.30432 6.26082ZM12 2.86955L12.259 3.66666H13.0972L12.419 4.15936L12.6781 4.95647L12 4.46386L11.3219 4.95647L11.5809 4.15936L10.9028 3.66666H11.7409L12 2.86955Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.96679 4.43476L10.2258 5.23191H11.0639L10.3858 5.72457L10.6449 6.52168L9.96679 6.02907L9.2886 6.52168L9.54768 5.72457L8.86954 5.23191H9.70771L9.96679 4.43476ZM14.0332 4.43476L14.2923 5.23191H15.1304L14.4523 5.72457L14.7114 6.52168L14.0332 6.02907L13.3551 6.52168L13.6142 5.72457L12.9361 5.23191H13.7742L14.0332 4.43476ZM13.2507 6.78259L13.5097 7.57974H14.3478L13.6697 8.0724L13.9288 8.86951L13.2507 8.3769L12.5726 8.86951L12.8316 8.0724L12.1535 7.57974H12.9916L13.2507 6.78259ZM10.7494 6.78259L11.0084 7.57974H11.8466L11.1684 8.0724L11.4275 8.86951L10.7494 8.3769L10.0712 8.86951L10.3303 8.0724L9.65216 7.57974H10.4903L10.7494 6.78259Z"
        fill="#F0F0F0"
      />
    </Icons>
  );
}
